export const baseUrl = process.env.REACT_APP_API_URL;
export const telegramName = process.env.REACT_APP_TELEGRAM_BOT_NAME;

export const API_AUTH_LOGIN = `/api/user/login`;
export const API_USER_VOTE = `/api/user/vote`;
export const API_MINING_INFO = `/api/mining/info`;
export const API_MINING_UNLOCK = `/api/mining/unlock`;
export const API_MINING_RELEASE = `/api/mining/release`;
export const API_MINING_ACTIVATE = `/api/mining/activeCard`;